import React     from 'react';
import PropTypes from 'prop-types';

import { ChangeMonthlyAnnual } from './change-acme/change-annual-acme';
import { ChangePlanAcme }      from './change-acme/change-plan-acme';
import { ChangePlanBm }        from './change-bm/change-plan-bm';
import { ChangePlanQkn }       from './change-qkn/change-plan-qkn';
import { ReactivateSimpModal } from './change-acme/reactivate-simp-modal';
import { ForceClose }          from '../force-close';
import { useGlobalCtx }        from '../../../context/ctx-hook';
import { getQknSubscription }  from '../../../context/selectors/bill-selectors';
// import * as ProductSelectors   from '../../../context/selectors/product-selectors';
// import * as UserSelectors      from '../../../context/selectors/user-selectors';
// import * as TimeHelpers        from '../../../helpers/time-helpers';


const ChangePlanModal = (props) => {
  const {state} = useGlobalCtx();
  // console.log(props);
  const COUNTRY = state.country;
  const QKN_SUB = getQknSubscription(state, COUNTRY);
  // console.log(QKN_SUB);
  const QKN_SUB_ACTIVE = QKN_SUB?.txnId ? QKN_SUB?.bundleSub?.active : QKN_SUB?.active;
  // console.log(QKN_SUB_ACTIVE);
  // const QKN_SUB = state.subscriptions[`quicken-${COUNTRY}`];
  // const BUNDLED_PRODUCT_LINES = state?.subscriptions?.bundles?.flatMap(bundle =>
  // bundle?.subscriptions?.map(sub => sub?.productLineUriName) || []
  // );
  // console.log('props:', props);
  // console.log('BUNDLED_PRODUCT_LINES:', BUNDLED_PRODUCT_LINES);

  // const HAS_BUNDLED_QKN = BUNDLED_PRODUCT_LINES?.some(line =>
  // ['quicken-us', 'quicken-ca'].includes(line)
  // );



  if (props.ctx.product === 'acme' && state?.subscriptions?.acme) {
    const SUB = state?.subscriptions?.acme;
    if (SUB?.active) {
      if(SUB.renewalFrequency === 'P1M') {
      // if (IS_MONTHLY) {
        return <ChangeMonthlyAnnual {...props} />;
      } else {
        return <ChangePlanAcme {...props}/>;
      }
      // return SUB.renewalFrequency === 'P1M'
      // ? <ChangePlanAcme {...props} />
      // : <ForceClose onClose={props.onClose}/>;
    } else {
      return <ReactivateSimpModal {...props} />;
    }
  } else if ((props.ctx.product === 'billmanager' || props.ctx.product === 'billmanager-promotion')  && QKN_SUB_ACTIVE) {
    // console.log('loading ChangePlanBm');
    return <ChangePlanBm {...props} />;
  } else if (QKN_SUB && ['quicken-us', 'quicken-ca'].includes(props.ctx.product)) {
    // Check the same validation logic as we do on the homepage when opening this modal
    // If they are in a state where buttons would be disabled, close the modal to force them into the flow of turning AR back on
    // const {
    //   autoRenew,
    //   expireOn,
    // } = ProductSelectors.getSubscription(state, `quicken-${COUNTRY}`);
    // const PAYMENT = UserSelectors.getProductsPaymentMethod(`quicken-${COUNTRY}`, state);
    // const HAS_PAYMENT = (!PAYMENT.isDeclined && !PAYMENT.isHardDeclined);
    // const DISTANCE = TimeHelpers.getDaysOut(expireOn);
    // const DAYS_LEFT_OVER_45   = DISTANCE === 'MID';
    // const DAYS_LEFT_LESS_45   = DISTANCE === 'NEAR';
    // const RENEW_ELGIBLE = (DAYS_LEFT_OVER_45 || (DAYS_LEFT_LESS_45 && autoRenew && HAS_PAYMENT));

    // return RENEW_ELGIBLE
    // ? <ChangePlanQkn {...props} />
    // : <ForceClose onClose={props.onClose}/>;
    return <ChangePlanQkn {...props} />;
  } else {
    return <ForceClose onClose={props.onClose}/>;
  }
};

ChangePlanModal.displayName = 'ChangePlanModal';

ChangePlanModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  ctx:     PropTypes.shape({
    product: PropTypes.string.isRequired
  })
};

export { ChangePlanModal };
